/**
 * Utility functions for array operations in DynamicTable
 */

/**
 * Compare arrays ignoring the first element
 * @param {Array} array1 - First array to compare
 * @param {Array} array2 - Second array to compare
 * @returns {boolean} - True if arrays are equal (ignoring first element)
 */
export function compareArraysIgnoringFirstElement(array1, array2) {
  if (array1.length !== array2.length) {
    return false;
  }
  
  for (let i = 0; i < array1.length; i++) {
    const subArray1 = array1[i].slice(1);
    const subArray2 = array2[i].slice(1);
    
    if (subArray1.length !== subArray2.length) {
      return false;
    }
    
    if (subArray2[0]?.length === 0 && subArray1[0]?.[0]?.length === 0) {
      return true;
    }
    
    for (let j = 0; j < subArray1.length; j++) {
      let value1 = subArray1[j];
      if (value1 && value1[0] && value1[0].length !== undefined) {
        value1 = value1[0];
      }
      
      const value2 = subArray2[j];
      const isEmptyCase = value2 === "" &&
        (value1 === "" ||
          JSON.stringify(value1) === JSON.stringify(["", ""]));

      if (isEmptyCase) {
        continue;
      }
      
      if (JSON.stringify(value1) !== JSON.stringify(value2)) {
        return false;
      }
    }
  }

  return true;
}

/**
 * Deep clone an array or object
 * @param {any} obj - Object to clone
 * @returns {any} - Cloned object
 */
export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Update cell value in rows array
 * @param {Array} rows - Current rows array
 * @param {number} rowIndex - Index of the row to update
 * @param {number} colIndex - Index of the column to update
 * @param {string} value - New value
 * @param {number} part - Part index for split mode (0 or 1)
 * @param {boolean} splitMode - Whether split mode is enabled
 * @returns {Array} - Updated rows array
 */
export function updateCellInRows(rows, rowIndex, colIndex, value, part, splitMode) {
  const updatedRows = [...rows];
  updatedRows[rowIndex] = [...updatedRows[rowIndex]];

  if (splitMode) {
    const currentValue = updatedRows[rowIndex][colIndex] || ['', ''];
    currentValue[part] = value;
    updatedRows[rowIndex][colIndex] = currentValue;
  } else {
    updatedRows[rowIndex][colIndex] = value;
  }

  return updatedRows;
}
